module.exports = __webpack_public_path__ + "img/cuenta_binance.be48782e.jpg";